<template>
  <div class="switchWrap">
    <div class="switch" @click="toggle">
      <span class="circle main-second-bg" :class="isChecked ? 'circleChecked' : 'circleCheckOut'" />
      <p
        class="boxStyle"
        :class="isChecked ? 'switchBottomChecked blue-bg' : 'switchBottom gray-bg'"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'c-switch-big',
  data() {
    return {
      isChecked: this.value,
    };
  },
  props: {
    // 控制开关开启关闭
    value: {
      default: true,
      type: Boolean,
    },
  },
  watch: {
    value(val) {
      this.isChecked = val;
    },
    isChecked(val) {
      this.$emit('onchange', val);
    },
  },
  methods: {
    toggle() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

// .light {
//   .circle {
//     background-color: red;
//   }
// }

// .dark {
//   .circle {
//     background-color: $dark-bg-second;
//   }
// }

.switchWrap {
  cursor: pointer;
  position: relative;

  .circle {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    top: 4px;
  }

  .circleChecked {
    transform: translateX(23px);
    transition: all 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
  }

  .circleCheckOut {
    transform: translateX(5px);
    transition: all 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
  }

  .boxStyle {
    width: 48px;
    height: 28px;
    border-radius: 28px;
  }

  .switchBottom {
  }

  .switchBottomChecked {
  }
}
</style>
